import React from 'react';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { OrderUtil } from '../../../../../types/order/';
import { FlowType } from '../../../../../types/order/orderFlow';

export default function OrderTypeFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<string>) {
  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.orderType || [])]}
      text={item => OrderUtil.typeToString(item as FlowType)}
      onRemove={i => {
        filterProps.orderType?.delete(i);
        if (!filterProps.orderType?.size) filterProps.orderType = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
